export type BootstrapScope = "buyer" | "supplier" | "admin" | "operator" | "global"

export const COOKIE_KEYS = {
    // Obfuscated cookie keys used by frontend-owned cookies.
    preferencesPrefix: "pcx_a9f1p",
    themeBootstrap: "pcx_t2m8v",
    themeBootstrapUserPrefix: "pcx_t2m8v_u",
    activeUserScope: "pcx_u7s1p",
    activeUserScopeByRole: {
        buyer: "pcx_u7s1p_b",
        supplier: "pcx_u7s1p_s",
        admin: "pcx_u7s1p_a",
        operator: "pcx_u7s1p_o",
        global: "pcx_u7s1p",
    },
    themeBootstrapByScope: {
        buyer: "pcx_t2m8v_b",
        supplier: "pcx_t2m8v_s",
        admin: "pcx_t2m8v_a",
        operator: "pcx_t2m8v_o",
        global: "pcx_t2m8v",
    },
    rememberEmail: "pcx_r4k7q",
} as const

export const buildUserScopeHash = (userId: number): string => {
    const seed = `pallet-exchange-user-${userId}`
    let primaryHash = 2166136261
    let secondaryHash = 334214467

    for (let index = 0; index < seed.length; index += 1) {
        const charCode = seed.charCodeAt(index)
        primaryHash ^= charCode
        primaryHash = Math.imul(primaryHash, 16777619)

        const reverseCharCode = seed.charCodeAt(seed.length - 1 - index)
        secondaryHash ^= reverseCharCode
        secondaryHash = Math.imul(secondaryHash, 2246822519)
    }

    const primaryPart = (primaryHash >>> 0).toString(36).padStart(7, "0")
    const secondaryPart = (secondaryHash >>> 0).toString(36).padStart(7, "0")
    return `${primaryPart}${secondaryPart}`
}

export const resolveThemeBootstrapCookieKeyFromScopeHash = (scopeHash: string): string => {
    return `${COOKIE_KEYS.themeBootstrapUserPrefix}_${scopeHash}`
}

export const resolveThemeBootstrapCookieKeyForUser = (userId: number): string => {
    return resolveThemeBootstrapCookieKeyFromScopeHash(buildUserScopeHash(userId))
}

export const resolveBootstrapScopeFromRole = (role?: string | null): BootstrapScope => {
    const normalized = (role || "").trim().toLowerCase()
    if (normalized === "buyer") return "buyer"
    if (normalized === "supplier") return "supplier"
    if (normalized === "admin") return "admin"
    if (normalized === "operator") return "operator"
    return "global"
}

export const resolveBootstrapScopeFromPathname = (pathname?: string | null): BootstrapScope => {
    const normalized = (pathname || "").toLowerCase()
    if (normalized.includes("/dashboard/buyer")) return "buyer"
    if (normalized.includes("/dashboard/supplier")) return "supplier"
    if (normalized.includes("/dashboard/admin") || normalized.includes("/admin")) return "admin"
    if (normalized.includes("/dashboard/operator")) return "operator"
    return "global"
}

export const resolveThemeBootstrapCookieKey = (scope: BootstrapScope): string => {
    return COOKIE_KEYS.themeBootstrapByScope[scope] ?? COOKIE_KEYS.themeBootstrapByScope.global
}

export const resolveActiveUserScopeCookieKey = (scope: BootstrapScope): string => {
    return COOKIE_KEYS.activeUserScopeByRole[scope] ?? COOKIE_KEYS.activeUserScope
}
